import { Box, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { colors } from "../../constants/design.constants";

export const Loading: React.FC<any> = (props: any) => {
  const { loading, text } = props;
  const [showLoading, setShowLoading] = useState(false);

  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  const init = async () => {
    await delay(700);
    setShowLoading(true);
  };

  useEffect(() => {
    init();
  }, [loading]);

  useEffect(() => {
    if (!loading) setShowLoading(false);
  }, [loading]);

  if (loading && showLoading) {
    return (
      <Box
        position="fixed"
        top="0"
        left={{ base: 0, lg: "260px" }}
        w={{ base: "100vw", lg: "calc(100vw - 260px)" }}
        h="100%"
        zIndex={99}
        bg="rgba(9, 10, 12, 0.82)"
        backdropFilter="blur(6px)"
      >
        <div className="flex flex-col items-center justify-center h-full gap-4">
          <Spinner
            thickness="2px"
            speed="0.7s"
            emptyColor={colors.border}
            color={colors.signal}
            size="xl"
          />
          {text && (
            <div className="text-center text-sm text-muted-foreground tracking-wide max-w-sm px-4">
              {text}
            </div>
          )}
        </div>
      </Box>
    );
  }

  return <></>;
};
